import { StandardEvents } from '@shopify/events';
let requestNumber = 0;
async function refreshCount(event) {
  const currentRequest = ++requestNumber;
  try {
    if (event?.promise) await event.promise;
    const header = document.querySelector('.r-header');
    if (!header) return;
    const response = await fetch(header.dataset.cartUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (currentRequest !== requestNumber) return;
    document.querySelectorAll('.r-cart-count').forEach(count => { count.textContent = String(cart.item_count); });
  } catch {}
}
document.addEventListener(StandardEvents.cartLinesUpdate, refreshCount);
window.addEventListener('pageshow', event => { if (event.persisted) refreshCount(); });
document.addEventListener('click', event => {
  const link = event.target.closest('.r-mobile-menu a');
  if (link) link.closest('details').open = false;
});
